import { memo, useCallback, useContext } from 'react'
import NavBarButton from '../NavBarButton/NavBarButton'
import GeoContext from 'contexts/geoContext'
import CurrencyContext from 'contexts/currencyContext'
import Flag from 'LuxKit/Flag'
import ModalContext from 'contexts/ModalContext'
import config from 'constants/config'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import NavBarCurrencyLanguageModal, { NavBarCurrencyLanguageDialog } from './NavBarCurrencyLanguageModal'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
}

function NavBarRegionButton(props: Props) {
  const intl = useIntl()
  const currentCurrency = useContext(CurrencyContext)
  const { currentRegionCode } = useContext(GeoContext)
  const showModal = useContext(ModalContext)
  const languageSelectorFlag = useLabFeatureFlag(LabFeatureFlags.enableLanguageSelector)
  const regionCurrencyTitle = intl.formatMessage({
    id: 'jZ_em4vQCeUJW4EVMsbw',
    defaultMessage: 'Select your region & currency',
    description: 'Modal title for region and currency selection in the navigation bar',
  })
  const regionCurrencyLanguageTitle = intl.formatMessage({
    id: 'niQoVEqXi3LmIJ_1E7Cc',
    defaultMessage: 'Region, currency & language',
    description: 'Modal title for region, currency and language selection in the navigation bar',
  })

  const onClick = useCallback(() => {
    showModal(resolve => <NavBarCurrencyLanguageDialog
      height="full"
      size="S"
      tabletHeight="auto"
      title={languageSelectorFlag?.enabled ? regionCurrencyLanguageTitle : regionCurrencyTitle}
    >
      <NavBarCurrencyLanguageModal
        showLanguageTab={!!languageSelectorFlag?.enabled}
        onSelect={resolve}
      />
    </NavBarCurrencyLanguageDialog>)
  }, [showModal, languageSelectorFlag?.enabled, regionCurrencyLanguageTitle, regionCurrencyTitle])

  if (config.regions.length < 2) {
    return null
  }

  return <NavBarButton
    className={props.className}
    icon={<Flag countryCode={currentRegionCode} size="S" />}
    onClick={onClick}
    contentBreakpointMin="desktop"
  >
    {currentCurrency.toUpperCase()}
  </NavBarButton>
}

export default memo(NavBarRegionButton)
